import * as TYPE from '../types';

const initialState = {
    ir_template_settings: [],
    single_ir_template_setting: {
        item_receipt_template_id: '',
        template_name: '',
        company_name: '',
        company_address: '',
        company_email: '',
        company_landline: '',
        company_mobile: '',
        company_tin: '',
        is_default: false,
        logo: '',
        logo_preview: '',
        file_logo: null,
        type: '',
        off_default: false
    },
    loading: false,
    show_crop: false,
    crop_trigger: false,
    crop_isset: false,
    show_component: 'main',
}

const ItemReceiptTemplateSettingReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case TYPE.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case TYPE.GET_IR_TEMPLATE_SETTING:
            return {
                ...state,
                ir_template_settings: action.payload
            }
        case TYPE.SET_IR_TS_COMPONENT:
            return {
                ...state,
                show_component: action.payload
            }
        case TYPE.HANDLE_IR_TEMPLATE_INPUT:
            return {
                ...state,
                single_ir_template_setting: { ...state.single_ir_template_setting, [action.payload.name]: action.payload.value }
            }
        case TYPE.HANDLE_SET_IR_DEFAULT_TEMPLATE:
            return {
                ...state,
                single_ir_template_setting: { ...state.single_ir_template_setting, ...action.payload }
            }
        case TYPE.CLEAR_IR_TEMPLATE_SETTING:
            return {
                ...state,
                single_ir_template_setting: {
                    item_receipt_template_id: '',
                    template_name: '',
                    company_name: '',
                    company_address: '',
                    company_email: '',
                    company_landline: '',
                    company_mobile: '',
                    is_default: false,
                    logo: '',
                    logo_preview: '',
                    type: '',
                    file_logo: null,
                    off_default: false
                },
                loading: false,
                show_crop: false,
                crop_trigger: false,
                crop_isset: false,
                show_component: 'main'
            }
        case TYPE.IR_TS_SHOW_CROP:
            return {
                ...state,
                show_crop: action.payload
            }
        case TYPE.IR_TS_LOGO_PREVIEW:
            return {
                ...state,
                single_ir_template_setting: { ...state.single_ir_template_setting, logo_preview: action.payload },
                show_crop: true
            }
        case TYPE.IR_TS_CROP_LOGO:
            return {
                ...state,
                single_ir_template_setting: { ...state.single_ir_template_setting, file_logo: action.payload.file_logo },
                crop_trigger: action.payload.crop_trigger
            }
        case TYPE.IR_TS_REMOVE_LOGO:
            return {
                ...state,
                single_ir_template_setting: { ...state.single_ir_template_setting, ...action.payload }
            }
        case  TYPE.IR_TS_CROP_TRIGGER:
            return {
                ...state,
                crop_trigger: action.payload
            }
        case TYPE.GET_SINGLE_IR_TS:
            return {
                ...state,
                single_ir_template_setting: { ...state.single_ir_template_setting, ...action.payload }
            }
        case TYPE.IR_TS_CROP_ISSET:
            return {
                ...state,
                crop_isset: action.payload
            }
        default:
            return state;
    }
}


export default ItemReceiptTemplateSettingReducer;